export const SET_STORIES = 'SET_STORIES';
export const SET_STORY = 'SET_STORY';
export const ADD_STORY = 'ADD_STORY';
export const ADD_STORIES = 'ADD_STORIES';
export const UPDATE_STORY = 'UPDATE_STORY';
export const REMOVE_STORY = 'REMOVE_STORY';
export const CLEAR_STORY = 'CLEAR_STORY';
export const CLEAR_STORIES = 'CLEAR_STORIES';
